// extracted by mini-css-extract-plugin
export default {"hsMobileFooter":"MobileFooter_hsMobileFooter__mO50E","moreMenuIcon":"MobileFooter_moreMenuIcon__KUrnW"};